var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Finance/coins 2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M5.25 3.96741C3.08138 4.61282 1.5 6.62173 1.5 9C1.5 11.3783 3.08138 13.3872 5.25 14.0326M16.5 9C16.5 11.8995 14.1495 14.25 11.25 14.25C8.35051 14.25 6 11.8995 6 9C6 6.10051 8.35051 3.75 11.25 3.75C14.1495 3.75 16.5 6.10051 16.5 9Z",
    stroke: "#726C6C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaid);
export default __webpack_public_path__ + "static/media/paid.26167dca1c9f14061db8831a2c90c929.svg";
export { ForwardRef as ReactComponent };